// extracted by mini-css-extract-plugin
export default {"sections":"mg_bJVe1d_1uRFWI8BAR","fields":"bfBMOGtlqsNX0i1E_LAT","checkbox-label":"CBxMvlH4Mu3BqiiaM68Q","form-checkbox":"_d2qRkxEZDfuZjqxjd8y"};